import React, { useRef, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";

export default function EmailAddressPicker({ formData, setFormData, name, inputOnly = false }) {
    const emailInputRef = useRef(null);

    // Ensure email_address is always an array
    useEffect(() => {
        if (!formData.email_address) {
            setFormData({ ...formData, email_address: [] });
        }
    }, [formData, setFormData]);

    const validateEmail = email => /\S+@\S+\.\S+/.test(email);

    const handleEmailInput = selected => {
        const validEmails = selected.filter(el => validateEmail(el.email));

        if (name.endsWith("edit")) {
            setFormData({ ...formData, email_address: validEmails });
        } else {
            setFormData({ ...formData, email_address: validEmails });
        }
    };

    const addEmailOnEnter = value => {
        const trimmed = value.trim();
        if (validateEmail(trimmed)) {
            setFormData({
                ...formData,
                email_address: [...(formData.email_address || []), { email: trimmed }],
            });
            emailInputRef.current.clear();
        }
    };

    const input = (
        <Typeahead
            id={`${name}-email-selection`}
            ref={emailInputRef}
            multiple
            labelKey="email"
            options={[]}
            placeholder="Add email address(es)..."
            allowNew={true}
            selected={formData.email_address || []}
            onChange={handleEmailInput}
            onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                    const value = emailInputRef.current.getInput().value;
                    addEmailOnEnter(value);
                }
            }}
        />
    );

    if (inputOnly) return input;

    return (
        <Form.Group as={Col} className="col-12 col-xl-10 min-w-user-emails">
            <Form.Label>Email(s)</Form.Label>
            {input}
        </Form.Group>
    );
}
